import React from "react";

import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";

const colors = {
    primary: "rgb(98, 110, 212)",
    secondary: "#6c757d",
    confirm: "#28a745",
    warning: "#ffc107",
    danger: "#dc3545",
    info:'#007bff',
    success: "#28a745",
}

const DefaultButton = ({
    loading = false, 
    disabled = false,
    text = "", 
    loadingtext = "",
    bg = Object.keys(colors)[0], 
    color = "white", 
    variant = "contained", 
    type = "button",
    icon = <></>,
    to,
    routeState = {},
    title = "",
    width = "auto",
    height = "auto",
    padding = "auto",
    style = {},
    onClick = (e) => void 0,
    search='',
    ...other
}) => {

    const history = useHistory();

    return (
   
            <Button
                variant={(bg=='confirm'?'success':bg)}
                disabled={loading || disabled}
                style={Object.assign({
                    // backgroundColor: (bg in colors ? colors[`${bg}`] : bg),
                    // color: (color in colors ? colors[`${color}`] : color),
                    // opacity:(loading || disabled)?0.5:1,
                    position: "relative",
                    textDecoration: "none",
                    minWidth: "auto",
                    width: width,
                    height: height,
                    padding: padding
                }, style)}
                type={type}
                onClick={(e) => {
                    onClick(e);
                    to && history.push({
                        pathname: to,
                        state: routeState,
                        search: search
                    });
                }}
                className="d-flex justify-content-center align-items-center"
            >
                 {loading &&<div className="spinner-border text-white" role="status"  >
        </div> }
                {icon}
                {loadingtext != "" && loading ? loadingtext : text}
            </Button>
    );
}

export default DefaultButton;